<template>
    <div v-if="isAvailable">
        <b-btn @click="showModal" variant="custom-danger" size="sm" class="fs-14 my-1">Отклонить</b-btn>
        <b-modal ref="cancel-modal" :title="title" v-model="isModalVisible" no-close-on-backdrop no-close-on-esc hide-header-close centered size="lg">
            <form-row-single-select
                v-model="form.decline_status_id"
                label="Причина отклонения"
                placeholder="Выберите причину отклонения"
                :options="declineStatuses"
                :v="$v.form.decline_status_id" />
            <form-row-edit-textarea label="Комментарий" v-model="form.comment" :v="$v.form.comment" :rows="5" />
            <form-row-single-line-document-upload title="Обоснование причины отклонения" v-model="form.attachment" :v="$v.form.attachment" :label-cols-sm="4" :label-cols-lg="4" />
            <div class="text-danger fw-600 text-center">ВНИМАНИЕ! Данная операция необратима.</div>
            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                    <b-button variant="custom-outline-secondary" class="text-uppercase mr-2" @click="cancelModal">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
                    <b-button variant="custom-danger" class="text-uppercase" :disabled="$v.$invalid" @click="rejectProposal">Отклонить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-unknown-volume-reject-proposal-button',
    props: {
        proposal: {
            type: Object,
            required: true
        },
        purchase: {
            type: Object,
            required: true
        }
    },
    validations: {
        form: {
            decline_status_id: { required },
            comment: {
                required,
                minLength: minLength(10),
            },
            attachment: { required }
        }
    },
    data() {
        return {
            isModalVisible: false,
            form: {
                decline_status_id: null,
                comment: '',
                attachment: null
            },
            isDataSending: false
        };
    },
    methods: {
        showModal() {
            this.form.decline_status_id = null;
            this.form.comment = '';
            this.form.attachment = null;
            this.isModalVisible = true;
        },
        cancelModal() {
            this.isModalVisible = false;
            this.form.decline_status_id = null;
            this.form.comment = '';
            this.form.attachment = null;
        },
        async rejectProposal() {
            this.isDataSending = true;
            if (await this.$api.personal.fl44UnknownVolume.rejectProposal(this.proposal.id, this.purchase.id, this.form)) {
                this.isModalVisible = false;
                this.$emit('refresh');
            }
            this.isDataSending = false;
        }
    },
    computed: {
        title() {
            return 'Вы действительно хотите отклонить ценовое предложение ' + this.proposal.supplier.name + '?';
        },
        declineStatuses() {
            if (!this.purchase.supplier_requirements.supplier_reqs_rating || (this.purchase.supplier_requirements.supplier_reqs_rating && this.proposal.supplier.rating >= 4.5)) {
                return this.$globalDictionaries.offerDeclineStatuses.filter((item) => item.id !== 1);
            }
            return this.$globalDictionaries.offerDeclineStatuses;
        },
        isAvailable() {
            return this.proposal.status.id === 'actual';
        }
    }
};
</script>
